import { getItem } from '../services/localStorage';
import { STATUS } from '~/common/status';
import DEFAULT_AVATAR from '~/assets/default-profile.jpg';

import { getCookie, TOKEN_COOKIE_KEY } from '~/services/cookies';

const USER_SEARCH_INITIAL_STATE = {
  isLoading: false,
  pagination: {
    showQuickJumper: true,
    showSizeChanger: true,
    total: 0,
    pageSize: 10
  },
  searchStatus: STATUS.ALL,
  searchText: ''
};

const PROGRESS_INITIAL_STATE = {
  isLoading: false
};

let auth;

try {
  auth = getItem('auth') || {};
} catch (e) {
  auth = {};
}

const tokenPair = auth.tokenPair || {};
const token = getCookie(TOKEN_COOKIE_KEY);
// overwork for AGENT-1375
if (token !== undefined && token !== '') {
  const decodedToken = atob(token.split('.')[1]);
  const jsonObj = JSON.parse(decodedToken);
  tokenPair.accessToken = token;
  tokenPair.refreshToken = token;
  tokenPair.login = jsonObj.sub;
}

const AUTH_INITIAL_STATE = {
  isLoggedIn: !!tokenPair.accessToken,
  firstName: auth.firstName,
  lastName: auth.lastName,
  login: tokenPair.login,
  accessToken: tokenPair.accessToken,
  refreshToken: tokenPair.refreshToken,
  error: null
};

const PRODUCTS_INITIAL_STATE = {
  error: null,
  items: [],
  isLoading: false,
  isLoaded: false
};

const PROFILE_INITIAL_STATE = {
  isLoaded: false,
  user: null,
  defaultAvatar: DEFAULT_AVATAR,
  error: null
};

const ROLES_INITIAL_STATE = {
  role: {},
  microproducts: [],
  airlines: [],
  error: null,
  loading: false
};

const EDIT_USER_ROLES_INITIAL_STATE = {
  roles: []
};

const USERS_INITIAL_STATE = {
  bulkRemoveOrganizations: [],
  bulkRemoveRoles: []
};

export default {
  auth: AUTH_INITIAL_STATE,
  progress: PROGRESS_INITIAL_STATE,
  users: USERS_INITIAL_STATE,
  usersSearch: USER_SEARCH_INITIAL_STATE,
  products: PRODUCTS_INITIAL_STATE,
  profile: PROFILE_INITIAL_STATE,
  roles: ROLES_INITIAL_STATE,
  editUserRoles: EDIT_USER_ROLES_INITIAL_STATE
};
